<template>
    <div class="submitWrapper paddBottom">
        <IndexHeaderOthers ref="indexHeader"></IndexHeaderOthers>
        <div class="main">
            <div class="conner">
                <div class="listData">
                    <el-descriptions class="margin-top" :column="1" size="small" border>
                        <el-descriptions-item v-for="(item, index) in ListData" :key="index">
                            <template slot="label">
                                {{ item.label }}
                            </template>
                            <span v-if="item.label != 'RELATED:'">{{ CircularqueryById[item.name] }}</span>
                            <div v-else>
                                    <div v-for="(item2,index) in CircularqueryById[item.name]" :key="index" style="display: inline-block">
                                        <div v-if="index != 0" style="display: inline-block;">/</div>
                                        <span style="color: #0a71d5;cursor: pointer" @click="goDetail(item2)">{{ item2  }}</span>
                                    </div>
                            </div>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
                <pre class="desc">{{CircularqueryById.content}}</pre>
                <div class="desc2">
                    SOURCE：{{CircularqueryById.detailUrl}}
                </div>
                <div class="desc2 desc3">
                    <a :href="CircularqueryById.innerUrl" target="_blank">{{ CircularqueryById.innerText }}</a>
                </div>
                <Message ref="message" :titles="titles" @getInfo="getInfos"></Message>
            </div>
        </div>
    </div>
</template>
<script>
import IndexHeaderOthers from "../../components/header/indexHeaderOthers.vue";
import Message from "../../components/page/Message";
import { format } from '../../utils/index.js'

export default {
    name: "circularsIndex",
    components: { IndexHeaderOthers, Message },
    data() {
        return {
            id: this.$route.query.id,
            ListData: [
                {
                    label: "TITLE:",
                    name: 'title',
                },
                {
                    label: "NUMBER:",
                    name: 'number',
                },
                {
                    label: "SUBJECT: ",
                    name: 'subject',
                },
                {
                    label: "DATE:",
                    name: 'atelTime',
                },
                {
                    label: "FROM:",
                    name: 'certification',
                },
                {
                    label: "RELATED:",
                    name: 'relatedNumber',
                },
            ],
            CircularqueryById: [],
            titles:'ATel',
            type:1, // 根据类型请求不同的接口
        };
    },
    methods: {
        //atel详情列表
        getCircularqueryById() {
          if(this.type == 2){
             const param = { number: this.id }
            this.$fetchGet('/cms-middle/astronAtel/queryByNumber', param).then((res) => {
                this.CircularqueryById = res.astronCircular;
                if(this.CircularqueryById.relatedNumber){
                    this.CircularqueryById.relatedNumber = this.CircularqueryById.relatedNumber.split(',')
                    // this.CircularqueryById.relatedNumber = [123,456,213,1231,312,312,3,13,123,12]
                }else{
                    this.CircularqueryById.relatedNumber = ['-']
                }
                if(this.CircularqueryById.atelTime){
                    this.CircularqueryById.atelTime = format(this.CircularqueryById.atelTime,
                        'yyyy-MM-dd hh:mm:ss')
                }else{
                    this.CircularqueryById.atelTime = '-'
                }

                this.NoticequeryById = res.astronNotice;
            });
          }else{
            const param = { id: this.id }
            this.$fetchGet('/cms-middle/astronAtel/queryById', param).then((res) => {
                this.CircularqueryById = res.astronCircular;
                if(this.CircularqueryById.relatedNumber){
                    this.CircularqueryById.relatedNumber = this.CircularqueryById.relatedNumber.split(',')
                    // this.CircularqueryById.relatedNumber = [123,456,213,1231,312,312,3,13,123,12]
                }else{
                    this.CircularqueryById.relatedNumber = ['-']
                }
                if(this.CircularqueryById.atelTime){
                    this.CircularqueryById.atelTime = format(this.CircularqueryById.atelTime,
                        'yyyy-MM-dd hh:mm:ss')
                }else{
                    this.CircularqueryById.atelTime = '-'
                }

                this.NoticequeryById = res.astronNotice;
            });
          }
           
        },
        format(date){
            var date = new Date(date);
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = date.getDate() + ' ';
            var h = date.getHours() + ':';
            var m = date.getMinutes() + ':';
            var s = date.getSeconds();
            var a = Y+M+D+h+m+s;
            return a;
        },
        getInfos(e){
            this.id = e.id
            this.getCircularqueryById()
        },
        goDetail(item) {
            let routedata = this.$router.resolve({
                path: "/Atel",
                query: {
                    id: item,
                    activeName:'ATel',
                    currentRowId:item,
                    eventId:0,
                    type:2,
                },
            });
            window.open(routedata.href, '_blank');
        }
    },
    created() {
      this.type = this.$route.query.type?this.$route.query.type:1;
    },
    mounted() {
        this.$refs.message.activeName = "ATel";
        this.getCircularqueryById()
        // window.addEventListener("scroll", this.$refs.indexHeader.scrollToTop, true);
    },
};
</script>
<style scoped>
.main {
    position: relative;
    margin-top: -70px;
    z-index: 99;
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 0 120px 0 0;
}

.conner {
    width: 1050px;
    margin: 0 auto;
    text-align: left;
}

.listData {
    padding-top: 30px;
}

.desc {
    border-top: 2px solid #008dc9;
    margin-top: 22px;
    background: #f7f9fb;
    padding: 12px;
    padding-bottom: 0;
}

pre{
    margin-bottom: 0;
    word-wrap: break-word;
    white-space: pre-wrap;
}
.desc2 {
    /* height: 410px; */
    background: #f7f9fb;
    padding: 12px;
    font-size: 14px;
}
.desc3{
    text-align: center;
}
.desc p {
    margin: 25px 32px;
    font-size: 14px;
    font-family: Alibaba Sans;
    font-weight: 500;
    color: #333333;
    line-height: 23px;
}

.desc p:first-child {
    margin-top: 44px;
}
</style>
